import { render } from "./Menu_pc.vue?vue&type=template&id=52594749&scoped=true"
import script from "./Menu_pc.vue?vue&type=script&lang=js"
export * from "./Menu_pc.vue?vue&type=script&lang=js"

import "./Menu_pc.vue?vue&type=style&index=0&id=52594749&scoped=true&lang=css"

import exportComponent from "D:\\fitbar\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52594749"]])

export default __exports__